import axiosInstance from './axios';

export const gameCategoryService = {
  getCategories: async (siteId?: string): Promise<any> => {
    const response = await axiosInstance.get('/admin/games/categories', {
      params: siteId ? { siteId } : {},
    });
    return response.data;
  },

  createCategory: async (data: { title: string; siteId?: number }): Promise<any> => {
    const response = await axiosInstance.post('/admin/games/categories', data);
    return response.data;
  },

  deleteCategory: async (id: number | string): Promise<any> => {
    const response = await axiosInstance.delete(`/admin/games/categories/${id}`);
    return response.data;
  },

  updateCategory: async (id: number | string, data: any): Promise<any> => {
    const response = await axiosInstance.patch(`/admin/games/categories/${id}`, data);
    return response.data;
  },

  toggleCategoryShow: async (id: number | string, firstPageEnabled: boolean): Promise<any> => {
    const response = await axiosInstance.patch(`/admin/games/categories/${id}/first-page`, {
      firstPageEnabled,
    });
    return response.data;
  },

  reorderCategories: async (ids: (number | string)[]): Promise<any> => {
    const response = await axiosInstance.patch('/admin/games/categories/reorder', { ids });
    return response.data;
  },

  getSubProviders: async (): Promise<any> => {
    const response = await axiosInstance.get('/admin/games/sub-providers');
    return response.data;
  },

  getGamesBySubProvider: async (params: {
    subProviderId: number | string;
    page: number;
    pageSize: number;
    siteId?: string | number;
    category?: string;
    isLive?: boolean;
    categoryId?: number | string;
    search?: string;
    hasFreeSpins?: boolean;
  }): Promise<any> => {
    const {
      subProviderId,
      page,
      pageSize,
      siteId,
      category,
      isLive,
      categoryId,
      search,
      hasFreeSpins,
    } = params;
    const response = await axiosInstance.get('/admin/games/by-sub-provider', {
      params: {
        subProviderId,
        page,
        pageSize,
        siteId,
        category: category || undefined,
        isLive: isLive || undefined,
        categoryId: categoryId || undefined,
        search: search || undefined,
        hasFreeSpins: hasFreeSpins !== undefined ? hasFreeSpins : undefined,
      },
    });
    return response.data;
  },

  getGamesByCategory: async (params: {
    categoryId: number | string;
    page: number;
    pageSize: number;
    siteId?: string | number;
    search?: string;
  }): Promise<any> => {
    const { categoryId, page, pageSize, siteId, search } = params;
    const response = await axiosInstance.get('/admin/games/by-category', {
      params: {
        categoryId,
        page,
        pageSize,
        siteId,
        search: search || undefined,
      },
    });
    return response.data;
  },

  getCollectionGames: async (categoryId: number | string): Promise<any> => {
    const response = await axiosInstance.get(
      `/admin/games/collections/by-category/${categoryId}/games?pageSize=20`,
    );
    return response.data;
  },

  updateCollection: async (
    categoryId: number | string,
    games: (number | string)[],
  ): Promise<any> => {
    const response = await axiosInstance.post(`/admin/games/collections`, { categoryId, games });
    return response.data;
  },
};
